import { ArrowForwardIosRounded } from '@mui/icons-material';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import { format } from 'date-fns';
import Badge from '../global/Badge';
import { formatDollarAmount } from '../../utils/global/helper';
import { CustomerOverview } from '../../types/customers';

interface Props {
  giftCard: CustomerOverview['giftCards'][number];
  onSelect?: (giftCardId: string) => void;
}

function CustomerGiftCardRow({ giftCard, onSelect }: Props) {
  const theme = useTheme();
  const { id, currentBalance, purchasedAt } = giftCard;

  // $0 balance gift cards are shown but are not clickable.
  const isClickable = currentBalance > 0;

  const balanceLabel = formatDollarAmount(currentBalance / 100);
  const purchasedDate = purchasedAt ? new Date(purchasedAt) : null;
  const subtitle = purchasedDate
    ? `Purchased ${format(purchasedDate, 'MMM d')} at ${format(
        purchasedDate,
        'h:mm a',
      )}`
    : '';

  return (
    <Box
      onClick={isClickable ? () => onSelect?.(id) : undefined}
      sx={{ cursor: isClickable ? 'pointer' : 'default' }}>
      <Box
        width="100%"
        display="flex"
        justifyContent="space-between"
        gap={0.25}
        py={2}
        borderBottom={`1px solid ${theme.palette.lightGrey.main}`}>
        <Stack gap={0.25}>
          <Typography variant="h4" component="p">
            {`${balanceLabel} gift card`}
          </Typography>
          {subtitle && (
            <Typography variant="body2" component="p">
              {subtitle}
            </Typography>
          )}
          <Badge
            text={`${balanceLabel} remaining`}
            colorScheme={currentBalance <= 0 ? 'grey' : 'secondary'}
            sx={{ width: 'fit-content' }}
          />
        </Stack>
        {isClickable && (
          <Box
            minHeight="100%"
            display="flex"
            alignItems="center"
            justifyContent="end">
            <ArrowForwardIosRounded
              sx={{
                fontSize: 18,
                color: 'text.disabled',
              }}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default CustomerGiftCardRow;
